import Clarity from '@microsoft/clarity';

export function initClarity(): void {
	const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
	const isProduction = import.meta.env.VITE_NODE_ENV === 'production';

	if (!isProduction || !projectId) {
		return;
	}

	Clarity.init(projectId);
}
